import { OverlayLoader } from 'components/Loaders'
import { actions, selectors } from 'data'
import { Bank } from 'data/Payments/BankTransfer/types'
import React, { Fragment, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Wrapper } from '../styles'
import Plaid from './Plaid'
import Yapily from './Yapily'
import Yodlee from './Yodlee'

type Props = {
  currency: string
  onBack: () => void
  onContinue?: () => void
  onSuccess: (bank: Bank) => void
  showWrapper?: boolean
}

const LinkBank = ({ currency, onBack, onContinue, onSuccess, showWrapper = true }: Props) => {
  const newBank = useSelector(selectors.payments.bankTransfer.getNewLinkedBank)
  const dispatch = useDispatch()

  const onMount = () => dispatch(actions.payments.createBankLink(currency))

  const WrapperComponent = showWrapper ? Wrapper : Fragment

  useEffect(() => {
    onMount()
  }, [currency])

  if (!newBank) {
    return (
      <WrapperComponent>
        <OverlayLoader />
      </WrapperComponent>
    )
  }

  if (newBank.partner === 'YODLEE') {
    return <Yodlee onBack={onBack} onContinue={onContinue} onSuccess={onSuccess} />
  }

  if (newBank.partner === 'YAPILY') {
    return (
      <Yapily
        id={newBank.id}
        institutions={newBank.attributes?.institutions ?? []}
        onBack={onBack}
        onSuccess={onSuccess}
      />
    )
  }

  if (newBank.partner === 'PLAID') {
    return <Plaid onBack={onBack} onSuccess={onSuccess} />
  }

  // Unknown provider
  return (
    <WrapperComponent>
      <span>Not supported yet</span>
    </WrapperComponent>
  )
}

export default LinkBank
